import Index from './index';

const ConsignmentContractOrder = () => {
  return <Index type={1}/>;
};

export default ConsignmentContractOrder;
